export default __webpack_public_path__ + "book.svg";